export const uniswapPoolArbUsdcArbitrumGoerli = {
  address: "0x9C653a10e4C51e9A784FeE3D5495de91cf3e1c51",
};
export const uniswapPoolWethUsdcArbitrumGoerli = {
  address: "0x035b26AF837e78798AD7c89050939B9AB2E192A0",
};
export const uniswapPoolGmxUsdcArbitrumGoerli = {
  address: "0x32859f88bB45fa5e25453Ba044D8fF5Fc243a8D9",
};
export const uniswapPoolWbtcWethArbitrumGoerli = {
  address: "0x27410978DC2E0271B618e8131E512B826bFe4753",
};

export const marginlyPoolArbUsdcArbitrumGoerli = {
  address: "0xA85151ef2756AdF90B232D94E31366547f4882e4",
};
export const marginlyPoolGmxUsdcArbitrumGoerli = {
  address: "0x8a6C5Ed1B834587FCc82bAd1b72e562a9FEfc2eA",
};
export const marginlyPoolWethUsdcArbitrumGoerli = {
  address: "0xea85A6a9A6e73Aa1203B3ee365D8e82B10feD7F8",
};
export const marginlyPoolGmxUsdcArbitrum = {
  address: "0x8a6C5Ed1B834587FCc82bAd1b72e562a9FEfc2eA",
};
